import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
// import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Paper from '@material-ui/core/Paper';
import Checkbox from '@material-ui/core/Checkbox';
import { useTranslation } from "react-i18next";
import { TablePagination } from '@material-ui/core';


function EnhancedTableHead(props) {
  const { t } = useTranslation();

  const { classes, onSelectAllClick, order, orderBy, numSelected, checkboxIndeterminate, checkboxChecked, rowCountIsCheck, onRequestSort, isOnSelectedAll, headCells } = props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {onSelectAllClick && <TableCell padding="checkbox">
          <Checkbox
            indeterminate={checkboxIndeterminate !== undefined ? checkboxIndeterminate : numSelected > 0 && numSelected < rowCountIsCheck}
            checked={checkboxChecked !== undefined ? checkboxChecked : rowCountIsCheck > 0 && numSelected === rowCountIsCheck}
            onChange={onSelectAllClick}
            inputProps={{ 'aria-label': 'select all desserts' }}
            color="primary"
            disabled={isOnSelectedAll}
          />
        </TableCell>}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric}
            padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            className={'font-weight-bolder text-capitalize'}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {t(`${headCell.label}`)}
              {orderBy === headCell.id ? (
                <span className={classes.visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired,
  rowCountIsCheck: PropTypes.bool.isRequired,
  checkboxIndeterminate: PropTypes.bool,
  checkboxChecked: PropTypes.bool,
  isOnSelectedAll: PropTypes.bool,
};



export default function AppTableMobile(props) {
  const { t } = useTranslation();

  const { 
    headCells,
    rowCount, 
    onSelectAllClick, 
    numSelected, 
    onRequestSort, 
    order, 
    orderBy, 
    checkboxIndeterminate, 
    checkboxChecked, 
    isOnSelectedAll, 
    rowCountIsCheck,
    rowsPerPageOptions, 
    rowsPerPage,
    minWidth,
    count,
    colSpan,
    page,
    handleChangePage,
    handleChangeRowsPerPage,
    TablePaginationActions ,
    isHideFooter
  } = props;
  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    table: {
      minWidth: minWidth ? minWidth : 650,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
  }));
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        <TableContainer>
          <Table
            className={classes.table}
            aria-labelledby="tableTitle"
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={numSelected.length}
              order={order}
              orderBy={orderBy}
              onSelectAllClick={onSelectAllClick}
              onRequestSort={onRequestSort}
              rowCount={rowCount}
              headCells={headCells}
              checkboxIndeterminate={checkboxIndeterminate}
              checkboxChecked={checkboxChecked}
              rowCountIsCheck={rowCountIsCheck}
              isOnSelectedAll={isOnSelectedAll}
            />
            {props.children}
          </Table>
        </TableContainer>
        {!isHideFooter && <TablePagination
          rowsPerPageOptions={rowsPerPageOptions}
          colSpan={colSpan}
          count={count}
          rowsPerPage={rowsPerPage}
          page={page}
          SelectProps={{
            inputProps: { "aria-label": "rows per page" },
            native: true,
          }}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
          ActionsComponent={TablePaginationActions}
          labelRowsPerPage={`${t("label.rows_per_page")}:`}
          labelDisplayedRows={({ from, to, count }) =>
            t("label.from_to", {
              from,
              to,
              count:
                count !== -1 ? count : `${t("text.more_than")} ${to}`,
            })
          }
        />}
      </Paper>
    </div>
  );
}

AppTableMobile.propTypes = {
  children: PropTypes.any,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func,
  order: PropTypes.oneOf(["asc", "desc"]).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  rowCountIsCheck: PropTypes.number,
  headCells: PropTypes.array.isRequired,
  checkboxIndeterminate: PropTypes.bool,
  checkboxChecked: PropTypes.bool,
  isOnSelectedAll: PropTypes.bool,
  minWidth: PropTypes.number,
  count: PropTypes.number,
  queries: PropTypes.object,
  handleChangePage: PropTypes.func,
  handleChangeRowsPerPage: PropTypes.func,
  TablePaginationActions: PropTypes.func,
  rowsPerPage: PropTypes.number,
  page: PropTypes.number,
  colSpan: PropTypes.number,
  rowsPerPageOptions: PropTypes.array,
  isHideFooter: PropTypes.bool
};